import Cookies from 'js-cookie';
import { RouteConfig } from 'vue-router';

import store from '@/store/store';
import { config } from '@/utils/config';

export const ssoLoginRoute: RouteConfig = {
  name: 'ssoLogin',
  path: 'sso-login',
  beforeEnter: (to, from, next) => {
    const token = Cookies.get(config.tokenCookie);
    if (token) {
      store.commit('auth/saveToken', token);
      Cookies.remove(config.tokenCookie);
      return next({ name: 'myProfile' });
    }
    next({ name: 'login' });
  }
};
